import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useUserStore from '../store/userStore';

/**
 * 페이지 컴포넌트에서 이 훅을 호출하면,
 * 해당 페이지는 반드시 로그인된 사용자만 접근할 수 있도록 보호됩니다.
 */
const useAuth = () => {
    const { user, isAuthChecked } = useUserStore();
    const navigate = useNavigate();

    useEffect(() => {
        // 인증 확인이 끝났는데도 user 정보가 없다면 로그인 페이지로 리디렉션합니다.
        if (isAuthChecked && !user) {
            navigate('/login');
        }
    }, [user, isAuthChecked, navigate]);

    return user;
};

export default useAuth;

